import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const MiniLoader = ({size,color}) => {
  return (
    <CircularProgress disableShrink size={size ?? 10} color={color}  />
  )
}

export default MiniLoader;